<div class="card mt-4" id="assignments">
  <div class="card-body px-0">
    @if (title) {
      <div class="page-header px-4">
        <h2>{{ title | translate }}</h2>
      </div>
    }
    @if ((assignments | assignmentsfilter: activeOnly).length < 1 && closed) {
      <app-card-empty
        [message]="'$message_no_closed_assignments$' | translate"
        [description]="'$when_assignment_closed_will_appear_here_label$' | translate" />
    }
    @if ((assignments | assignmentsfilter: activeOnly).length < 1 && !closed) {
      <app-card-empty
        [message]="'$message_noassignments$' | translate"
        [description]="'$press_button_to_continue_label$' | translate">
        <ng-template #button>
          <button
            class="btn btn-primary btn-capsule mx-auto"
            [permission]="globals.PERMISSION_ASSIGNMENT_CREATE"
            (click)="addAssignment()">
            <span>{{ '$title_createassignment$' | translate }}</span
            ><i class="material-icons mi-inline">add</i>
          </button>
        </ng-template>
      </app-card-empty>
    }
    @if ((assignments | assignmentsfilter: activeOnly).length > 0) {
      <div class="table-vertical-scroll h-100">
        <table class="table table-hover border-bottom">
          <thead>
            <tr>
              <th class="pl-4" colspan="3">{{ '$assignments$' | translate }}</th>
              @if (customerId === null) {
                <th>{{ '$customer_name$' | translate }}</th>
              }
              <th>{{ '$field_assignment_type$' | translate }}</th>
              <th colspan="2">{{ '$created_on$' | translate }}</th>
              <th>{{ '$status$' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (
              assignment of assignments | orderBy: 'addedDateTime' | assignmentsfilter: activeOnly;
              track assignment
            ) {
              <tr>
                <td class="text-nowrap cursor-pointer" (click)="viewAssignment(assignment)">
                  <app-assignment-number
                    [friendlyNumber]="assignment.friendlyNumber"
                    [reopenedDateTime]="assignment.reopenedDateTime" />
                </td>
                <td class="text-nowrap cursor-pointer" (click)="viewAssignment(assignment)">
                  {{ assignment.externalReferenceNo }}
                </td>
                <td
                  style="max-width: 190px"
                  class="text-truncate assignment cursor-pointer"
                  (click)="viewAssignment(assignment)">
                  <app-assignment-name [assignment]="assignment" />
                </td>
                @if (customerId === null) {
                  <td class="text-nowrap cursor-pointer" (click)="viewAssignment(assignment)">
                    @if (assignment.customerContact?.fullName !== null) {
                      {{ assignment.customerContact.salutationTypeId | resourceById | async }}
                      {{ assignment.customerContact.fullName }}
                    } @else {
                      {{ '$not_available$' | translate }}
                    }
                  </td>
                }
                <td class="text-nowrap cursor-pointer" (click)="viewAssignment(assignment)">
                  {{ assignment.assignmentTemplateName || ('$not_available$' | translate) }}
                </td>
                <td class="text-nowrap cursor-pointer" (click)="viewAssignment(assignment)">
                  {{ assignment.addedDateTime | companyDate }}
                </td>
                <td class="cursor-pointer" (click)="viewAssignment(assignment)">
                  {{ (assignment.hasOrders ? '$finances_order$' : '$finances_quotation$') | translate }}
                </td>
                <td>
                  <app-assignment-status-sticker
                    [statusId]="assignment.statusId"
                    (click)="viewAssignment(assignment)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  @if (assignments?.length > 0 && showCreateButton) {
    <div class="card-footer bg-white">
      <div class="d-flex justify-content-center mb-2">
        <a
          class="btn btn-primary btn-capsule text-white"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE"
          (click)="addAssignment()">
          <span>{{ '$title_createassignment$' | translate }}</span
          ><i class="material-icons mi-inline">add</i>
        </a>
      </div>
    </div>
  }
</div>
